export default __webpack_public_path__ + "static/media/a037-6.798e87dc.svg";